/**
 * Contact Information Constants (Issue #1310)
 *
 * Centralized contact email addresses for consistency across the application.
 * Update these values in one place to change them throughout the entire app.
 */

export const CONTACT_EMAILS = {
  privacy: 'privacy@localartistfairs.com',
  legal: 'legal@localartistfairs.com',
  support: 'support@localartistfairs.com',
  noreply: 'noreply@localartistfairs.com',
} as const;

export const COMPANY_INFO = {
  name: 'Local Artist Fairs',
  tagline: 'Connecting Artists and Communities',
} as const;
